export enum OrderStatus {
  Pending = 'pending',
  Processing = 'processing',
  PrepareShipment = 'prepare-shipment',
  Shipped = 'shipped',
  Completed = 'completed',
  Cancelled = 'cancelled',
  Refunded = 'refunded',
  Failed = 'failed',
  OnHold = 'on-hold',
}

/**
 * Color mapping for order status indicators
 * Maps OrderStatus enum to design system color tokens
 */
export const ORDER_STATUS_COLORS: Record<OrderStatus, string> = {
  [OrderStatus.Completed]: 'success.600',
  [OrderStatus.Processing]: 'warning.300',
  [OrderStatus.PrepareShipment]: 'warning.300',
  [OrderStatus.Shipped]: 'warning.300',
  [OrderStatus.Pending]: 'warning.300',
  [OrderStatus.Cancelled]: 'error.600',
  [OrderStatus.Refunded]: 'neutral.400',
  [OrderStatus.Failed]: 'error.600',
  [OrderStatus.OnHold]: 'neutral.400',
};

export const DEFAULT_ORDER_STATUS_COLOR = 'neutral.400';

